import encodeQueryData from "../utils/encodeQueryData";
import Fetch from "./Fetch";
import FormData from 'form-data';
import { env } from '../var/env';
import Storage from "../utils/storage";
import { clearAuthStorage } from '/src/features/auth/utils/authStorage';

const storageSession = Storage('session');
const storageLocal = Storage('local');
function client() {

    const url = env.PYTHON_APP_API_PATH + '/'

    const generateHeaders = (options = {}) => {
        const token = storageLocal.get('token');
        if (token) {
            options.Authorization = 'Bearer ' + token
        }

        return options;
    };

    const fetchInterceptorRequest = (url, options) => {
        options = {
            ...options,
            headers: {
                ...options.headers
            }
        };

        return { url, options };
    }
    const isAuthError = (error, response) => {
        const status = error?.status ?? response?.status;
        if (status === 401) return true;

        const detail = typeof error?.detail === 'string' ? error.detail.toLowerCase() : '';
        return detail.includes('token') && (detail.includes('invalid') || detail.includes('expired'));
    };
    const fetchInterceptorResponse = async (response, error, request) => {
        const authError = isAuthError(error, response);
        if (error === null || !authError || !storageLocal.get('token')) return [response, error];
        console.log('Token expired, refreshing token...');
        clearAuthStorage();

        window.location.href = "/login";
        return [response, error];

    }

    const apiCall = async (...arg) => {
        const { url, options } = fetchInterceptorRequest(...arg);
        let [response, error] = await Fetch(url, options);

        // A 401 on the login attempt itself just means "wrong credentials" -
        // it's not a session expiring, so it must not go through the
        // expired-token redirect and must be returned to the login form.
        if (url.endsWith('auth/login')) return [response, error];

        [response, error] = await fetchInterceptorResponse(response, error, { url, options })
        return [response, error];
    }

    return {
        get: function (uri, params = {}, responseType = "json", extraHeaders = { "Content-Type": "application/json" }) {

            const content = {
                method: 'get',
                headers: generateHeaders(extraHeaders),
                responseType
            };

            const data = encodeQueryData(params);

            return apiCall(url + uri + (data ? '?' + data : ''), content);

        },
        post: function (uri, data) {
            const content = {
                method: 'post',
                headers: generateHeaders()
            }

            if (data instanceof FormData === false) {
                content.headers = generateHeaders({ 'Content-Type': 'application/json' });
                content.body = JSON.stringify(data);
            }
            else {
                content.body = data;
            }

            if (uri === 'auth/login') {
                delete content.headers.Authorization;
            }

            return apiCall(url + uri, content);
        },
        put: function (uri, data) {
            const content = {
                method: 'put',
                headers: generateHeaders()
            }

            if (data instanceof FormData === false) {
                content.headers = generateHeaders({ 'Content-Type': 'application/json' });
                content.body = JSON.stringify(data);
            }
            else {
                content.method = 'post';
                uri = uri + '?_method=PUT';
                content.body = data;
            }

            return apiCall(url + uri, content);
        },
        delete: function (uri, params = {}) {
            const content = {
                method: 'delete',
                headers: generateHeaders({
                    'Content-Type': 'application/json',
                }),
            };

            const queryString = encodeQueryData(params);
            const fullUrl = queryString ? `${url}${uri}?${queryString}` : `${url}${uri}`;

            return apiCall(fullUrl, content);
        }

    }
}

export default client();